import { ConfigurationValues } from '@cutr/constants/windows/windows';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from '@/windows/primitives/Label';

import { GlassSelect } from '../../GlassSelect';
import { unboxLabel } from '../Configurations';
import { ConfigurationComponent } from '.';

const GlassTypeConfig = () => {
  const { t } = useTranslation();
  const labelId = useId();
  const inputId = useId();

  return (
    <>
      <Label id={labelId} htmlFor={inputId}>
        {t(`windows.configurations.glassType.label`)}
      </Label>
      <GlassSelect />
    </>
  );
};

const config: ConfigurationComponent<'glassType'> = {
  key: 'glassType',
  input: <GlassTypeConfig />,
  display: (value: ConfigurationValues['glassType']) => (
    <span>{unboxLabel(value.label)}</span>
  ),
};

export default config;
